export const DESKTOP_APP_IDS = [
  "assistants",
  "jarvis",
  "friday",
  "hermes",
  "knowledge",
  "research",
  "vault",
  "files",
  "dev",
  "database",
  "ide",
  "stats",
  "mail",
  "chat",
  "chill",
  "reminder",
  "hut",
  "settings",
  "system-settings",
  "terminal",
  "dashboard",
  "browser",
  "productivity",
  "inbox",
  "agent-control",
  "mission-control",
  "rules",
  "workspaces",
  "ai-control",
  "global-search",
  "shared-workspace",
  "resource-governor",
  "permissions",
  "app-studio",
  "coding-calendar",
  "deploy",
]

export const DESKTOP_APP_ID_SET = new Set(DESKTOP_APP_IDS)
export const DESKTOP_ESSENTIAL_APP_IDS = new Set(["assistants", "browser", "files", "terminal", "chat", "deploy", "settings", "dashboard", "global-search", "mail", "reminder", "chill", "hut", "hermes", "ai-control"])

export const DESKTOP_APP_LABELS = {
  assistants: "Assistants",
  jarvis: "JARVIS",
  friday: "FRIDAY",
  hermes: "HERMES",
  knowledge: "Knowledge",
  research: "Deep Research",
  vault: "Vault",
  files: "Dateimanager",
  dev: "Dev",
  database: "Datenbank",
  ide: "IDE",
  stats: "Stats",
  mail: "Mail",
  chat: "Live Chat",
  chill: "Chill",
  reminder: "Reminder",
  hut: "Hut & Heroes",
  settings: "Holos Einstellungen",
  "system-settings": "System Settings",
  terminal: "Terminal",
  dashboard: "Dashboard",
  browser: "Holos Browser",
  productivity: "Produktivität",
  inbox: "Universal Inbox",
  "agent-control": "Agent Control",
  "mission-control": "Mission Control",
  rules: "RuleBook",
  workspaces: "Arbeitsbereiche",
  "ai-control": "AI Control Center",
  "global-search": "Global Search",
  "shared-workspace": "Shared Workspace",
  "resource-governor": "Resource Governor",
  permissions: "Permission Center",
  "app-studio": "App Studio",
  "coding-calendar": "Coding Kalender",
  deploy: "Deploy",
}
